export default __webpack_public_path__ + "static/media/two.2e4237d8.png";